import React, { Component } from "react";
import Head from "../components/Head";
import { auth } from "../config/fire";
import { updateprof, updatephoto } from "../helpers/auth";
import Loader from "../components/Loader";
import CreateMeetModal from '../components/Modals/createMeetModal';
import Scheduled from './Scheduled';
import { DashboardContainer, DashMainWrapper, DashCalenderDiv } from './styles';


export default class MyEvents extends Component {

    constructor(props) {
        super(props);
        document.title = 'MyEvents';
        this.state = {
            user: auth().currentUser,
            loading: true,
            editEnable: false,
            modalVisibility: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.updateprofile = this.updateprofile.bind(this);
        this.updatepropic = this.updatepropic.bind(this);
    }

    componentDidMount() {
        this.setState({
            loading: false,
        })
    }

    async updateprofile(event) {
        event.preventDefault();
        this.setState({ error: '' });
        try {
            await updateprof(this.state.uname);
        } catch (error) {
            this.setState({ error: error.message });
        }
        this.setState({ editEnable: false })
    }
    async updatepropic(event) {
        event.preventDefault();
        this.setState({ error: '' });
        try {
            await updatephoto(this.state.upic);
        } catch (error) {
            this.setState({ error: error.message });
        }
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    render() {
        return (
            <DashboardContainer>
                <Head />
                {
                    this.state.loading ? <Loader /> :
                        <DashMainWrapper>
                            <DashCalenderDiv>
                                <p className='prof-usename'>Scheduled Events</p>
                                <Scheduled />
                            </DashCalenderDiv>
                        </DashMainWrapper>
                }
                {
                    this.state.modalVisibility &&
                    <CreateMeetModal
                        visibility={this.state.modalVisibility}
                        onClose={() => this.setState({ modalVisibility: false })}
                    />
                }
            </DashboardContainer >
        );
    }
};

